import {PhoneNumbersResponseBody} from '@dms/api/shared';

export const phoneNumbersResponseMock: PhoneNumbersResponseBody[] = [
  {
    code: 'CZE',
    name: 'Czech Republic',
    prefix: '+420',
    preferred: false,
  },
  {
    code: 'DEU',
    name: 'Germany',
    prefix: '+49',
    preferred: false,
  },
  {
    code: 'SVK',
    name: 'Slovakia',
    prefix: '+421',
    preferred: false,
  },
  {
    code: 'POL',
    name: 'Poland',
    prefix: '+48',
    preferred: false,
  },
  {
    code: 'AUT',
    name: 'Austria',
    prefix: '+43',
    preferred: false,
  },
  {
    code: 'FRA',
    name: 'France',
    prefix: '+33',
    preferred: false,
  },
  {
    code: 'ITA',
    name: 'Italy',
    prefix: '+39',
    preferred: false,
  },
  {
    code: 'ESP',
    name: 'Spain',
    prefix: '+34',
    preferred: false,
  },
  {
    code: 'GBR',
    name: 'United Kingdom of Great Britain and Northern Ireland',
    prefix: '+44',
    preferred: false,
  },
  {
    code: 'ALB',
    name: 'Albania',
    prefix: '+355',
    preferred: false,
  },
  {
    code: 'BEL',
    name: 'Belgium',
    prefix: '+32',
    preferred: false,
  },
  {
    code: 'BLR',
    name: 'Belarus',
    prefix: '+375',
    preferred: false,
  },
  {
    code: 'BIH',
    name: 'Bosnia and Herzegovina',
    prefix: '+387',
    preferred: false,
  },
  {
    code: 'BGR',
    name: 'Bulgaria',
    prefix: '+359',
    preferred: false,
  },
  {
    code: 'DNK',
    name: 'Denmark',
    prefix: '+45',
    preferred: false,
  },
  {
    code: 'EST',
    name: 'Estonia',
    prefix: '+372',
    preferred: false,
  },
  {
    code: 'FIN',
    name: 'Finland',
    prefix: '+358',
    preferred: false,
  },
  {
    code: 'HRV',
    name: 'Croatia',
    prefix: '+385',
    preferred: false,
  },
  {
    code: 'IRL',
    name: 'Ireland',
    prefix: '+353',
    preferred: false,
  },
  {
    code: 'ISL',
    name: 'Iceland',
    prefix: '+354',
    preferred: false,
  },
  {
    code: 'KAZ',
    name: 'Kazakhstan',
    prefix: '+7',
    preferred: false,
  },
  {
    code: 'CYP',
    name: 'Cyprus',
    prefix: '+357',
    preferred: false,
  },
  {
    code: 'LIE',
    name: 'Liechtenstein',
    prefix: '+423',
    preferred: false,
  },
  {
    code: 'LTU',
    name: 'Lithuania',
    prefix: '+370',
    preferred: false,
  },
  {
    code: 'LVA',
    name: 'Latvia',
    prefix: '+371',
    preferred: false,
  },
  {
    code: 'LUX',
    name: 'Luxembourg',
    prefix: '+352',
    preferred: false,
  },
  {
    code: 'HUN',
    name: 'Hungary',
    prefix: '+36',
    preferred: false,
  },
  {
    code: 'MLT',
    name: 'Malta',
    prefix: '+356',
    preferred: false,
  },
  {
    code: 'MDA',
    name: 'Moldova',
    prefix: '+373',
    preferred: false,
  },
  {
    code: 'MCO',
    name: 'Monaco',
    prefix: '+377',
    preferred: false,
  },
  {
    code: 'NLD',
    name: 'Netherlands',
    prefix: '+31',
    preferred: false,
  },
];
